<template>
    <v-card class="stats-hero pa-5 rounded-lg" flat outlined>
        <div class="stats-hero__inner">
            <div class="stats-hero__intro">
                <span class="stats-hero__eyebrow">Ideias de temas</span>
                <h2 class="stats-hero__title stardust--text">Sobre o que vamos escrever?</h2>
                <p class="stats-hero__subtitle mercury--text ma-0">
                    Ideias feitas sob medida para a sua especialidade — ou crie a sua.
                </p>
            </div>

            <div class="stats-hero__divider" aria-hidden="true"></div>

            <div class="stats-hero__tiles">
                <div class="stats-tile">
                    <div class="stats-tile__icon stats-tile__icon--primary">
                        <v-icon size="20" color="primary">mdi-lightbulb-on-outline</v-icon>
                    </div>
                    <div class="stats-tile__body">
                        <v-skeleton-loader v-if="loading" type="text" class="stats-tile__skeleton" />
                        <span v-else class="stats-tile__value stardust--text">{{ suggestionsCount }}</span>
                        <span class="stats-tile__label">Ideias de temas</span>
                    </div>
                </div>

                <div class="stats-tile">
                    <div class="stats-tile__icon stats-tile__icon--galaxy">
                        <v-icon size="20" color="galaxy">mdi-file-document-multiple-outline</v-icon>
                    </div>
                    <div class="stats-tile__body">
                        <v-skeleton-loader v-if="loading" type="text" class="stats-tile__skeleton" />
                        <span v-else class="stats-tile__value stardust--text">{{ articles.total || 0 }}</span>
                        <span class="stats-tile__label">Artigos gerados</span>
                    </div>
                </div>

                <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                        <div class="stats-tile" v-bind="attrs" v-on="on">
                            <div class="stats-tile__icon" :class="lowCredits ? 'stats-tile__icon--warning' : 'stats-tile__icon--primary'">
                                <v-icon size="20" :color="lowCredits ? 'warning' : 'primary'">mdi-flash</v-icon>
                            </div>
                            <div class="stats-tile__body">
                                <v-skeleton-loader v-if="loading" type="text" class="stats-tile__skeleton" />
                                <span v-else class="stats-tile__value" :class="lowCredits ? 'warning--text' : 'stardust--text'">{{ credits }}</span>
                                <span class="stats-tile__label">Créditos</span>
                            </div>
                        </div>
                    </template>
                    <span>{{ lowCredits ? 'Poucos créditos restantes. ' : '' }}Cada artigo criado usa 1 crédito do seu plano.</span>
                </v-tooltip>
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'ArtigosStatsHero',
    props: {
        suggestionsCount: { type: Number, default: 0 },
        articles: {
            type: Object,
            default: () => ({ total: 0, published: 0, scheduled: 0, draft: 0 }),
        },
        credits: { type: Number, default: 0 },
        loading: { type: Boolean, default: false },
        lowCreditThreshold: { type: Number, default: 3 },
    },
    computed: {
        lowCredits() {
            return Number(this.credits) <= Number(this.lowCreditThreshold)
        },
        breakdown() {
            
        },
    },
}
</script>

<style scoped>
.stats-hero {
    border: 1px solid #d3d9de !important;
    background: #fff;
}

.stats-hero__inner {
    display: flex;
    align-items: center;
    gap: 24px;
}

.stats-hero__intro {
    flex: 1 1 auto;
    min-width: 0;
}

.stats-hero__eyebrow {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--v-primary-base);
    margin-bottom: 6px;
}

.stats-hero__title {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.25;
    margin: 0 0 4px 0;
}

.stats-hero__subtitle {
    font-size: 13px;
    line-height: 1.5;
}

.stats-hero__divider {
    align-self: stretch;
    width: 1px;
    background: #eef0f3;
    flex: 0 0 auto;
}

.stats-hero__tiles {
    flex: 0 0 400px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
}

.stats-tile {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.stats-tile__icon {
    flex: 0 0 auto;
    width: 34px;
    height: 34px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.stats-tile__icon--primary {
    background: rgba(0, 115, 230, 0.1);
}

.stats-tile__icon--galaxy {
    background: rgba(112, 105, 161, 0.14);
}

.stats-tile__icon--warning {
    background: rgba(251, 140, 0, 0.14);
}

.stats-tile__body {
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
}

.stats-tile__label,

.stats-tile__value {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.1;
    font-variant-numeric: tabular-nums;
}

.stats-tile__label {
    font-size: 10.5px;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--v-mercury-base);
    margin-top: 2px;
}

.stats-tile__skeleton {
    width: 48px;
    margin-bottom: 2px;
}

.stats-tile__skeleton >>> .v-skeleton-loader__text {
    height: 22px;
    margin: 0;
}

@media (max-width: 960px) {
    .stats-hero__inner {
        flex-direction: column;
        align-items: stretch;
        gap: 18px;
    }

    .stats-hero__divider {
        display: none;
    }

    .stats-hero__tiles {
        flex: 1 1 auto;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 12px;
    }

    .stats-tile__value {
        font-size: 20px;
    }
}

@media (max-width: 560px) {
    .stats-hero {
        padding: 16px !important;
    }

    .stats-hero__title {
        font-size: 18px;
    }

    .stats-hero__tiles {
        grid-template-columns: 1fr;
        gap: 8px;
    }

    .stats-tile {
        align-items: center;
        gap: 10px;
        min-width: 0;
        padding: 8px 10px;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.04);
    }

    .stats-tile__icon {
        width: 30px;
        height: 30px;
    }

    .stats-tile__body {
        flex-direction: row;
        align-items: baseline;
        gap: 8px;
        min-width: 0;
    }

    .stats-tile__value {
        font-size: 18px;
        flex: 0 0 auto;
    }

    .stats-tile__label {
        font-size: 9.5px;
        line-height: 1.25;
        letter-spacing: 0.07em;
        margin-top: 0;
        white-space: normal;
        overflow-wrap: normal;
        word-break: normal;
    }
}
</style>
